import { IRootState } from 'app/shared/reducers';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PageTitel } from './page-titel';
import { SmallTextWithIcone } from './small-text-with-icone';
import './text-style.scss';


export interface ITextParag {
  textTitle?: any;
  smallText?: any;
    size?: any;
    icon?: any;
    colorText?: any;
  }


export const TextParag = ({ textTitle, smallText, icon, size = 'D',colorText='#4e4e4e' }: ITextParag) => {
 
  return (
    <div>
       <PageTitel text={textTitle} />
       <SmallTextWithIcone text={smallText} icon={icon} size={size}/>
    </div>
  );
};
